import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { PlatformType } from "@redotech/redo-merchant-platform-rpc/schema/get-enabled-platforms";
import { GeneralPermissions } from "@redotech/redo-model/permissions";
import { createContext, memo } from "react";

export interface InventoryManagementSuiteStatuses {
  imsEnabled: boolean;
}

export const EcommerceProvidersContext = createContext<
  PlatformType[] | undefined
>(undefined);

export const EcommerceProvidersContextProvider = memo(
  function EcommerceProvidersContextProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const platformClient = useRequiredContext(RedoPlatformAuthRpcClientContext);
    const canViewEnabledPlatforms = useHasPermission(GeneralPermissions.OTHER);

    const isCommentsoldActiveLoad = useLoad(() => {
      if (!canViewEnabledPlatforms) {
        return Promise.resolve([]);
      }
      return platformClient.getEnabledPlatforms(null);
    }, [platformClient, canViewEnabledPlatforms]);

    return (
      <EcommerceProvidersContext.Provider value={isCommentsoldActiveLoad.value}>
        {children}
      </EcommerceProvidersContext.Provider>
    );
  },
);
